const ClickOutsideManager = (() => {
  let listeners = [];
  let isListening = false;

  function handleMouseDown(e) {
    listeners.forEach(fn => fn(e));
  }

  return {
    subscribe(fn) {
      listeners.push(fn);
      if (!isListening) {
        document.addEventListener("mousedown", handleMouseDown, true);
        isListening = true;
      }
      return () => this.unsubscribe(fn);
    },
    unsubscribe(fn) {
      listeners = listeners.filter(l => l !== fn);
      if (listeners.length === 0 && isListening) {
        document.removeEventListener("mousedown", handleMouseDown, true);
        isListening = false;
      }
    }
  };
})();

export default ClickOutsideManager;